/**
 * Invoice Component
 */

import { getFormattedDateFromGraphQL, isPastDue } from '../../../../utils/date';
import './styles.scss';

import * as React from 'react';

import { Span } from '../../../atoms/text/Label';
import CheckoutAmounts from '../../../pages/Checkout/CheckoutAmounts';
import PrintableDocument from '../PrintableDocument';
import InvoiceInformation from './InvoiceInformation';
import InvoiceLineItems from './InvoiceLineItems';
import InvoicePaymentMethods from './InvoicePaymentMethods';

interface IOwnProps {
  className?: string;
  data: GQL.IOrder;
}

type InvoiceProps = IOwnProps;

export default class Invoice extends React.Component<InvoiceProps, {}> {

  renderDate(date: string) {
    return getFormattedDateFromGraphQL(date);
  }

  render() {
    const { data } = this.props;
    const isPaid = data.payment_status === 'PaymentReceived';

    return (
      <PrintableDocument
        type="invoice"
        identification={{
          title: 'Invoice',
          subtitle: isPaid ?
            `Paid on ${this.renderDate(data.payment_received_date)}`
            : (
              <span className={isPastDue(data.payment_due_date) ? 'color--dangerous' : ''}>
                Due date: {this.renderDate(data.payment_due_date)}
              </span>
            ),
        }}
        title={data.project_details!.brand!}
        subtitle={data.project_details!.product!}
        metadata={(<>
          <Span variant="description" size="large" textColor="bw7">{`Invoice #${data.invoice_number}`}</Span>
          <Span variant="description" size="large" textColor="bw7">
            {this.renderDate(data.order_date)}
          </Span>
        </>)}
      >
        <InvoiceInformation order={data} />
        <InvoiceLineItems order={data} />
        <CheckoutAmounts order={data} context="invoice" />
        {!isPaid && <InvoicePaymentMethods currency={data.currency_code as GQL.Currency} />}
      </PrintableDocument>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/account/Invoice/index.tsx